import { isInIframe } from './env';

/**
 * 点击链接的拦截器，当在iframe中时，通过postMessage发送消息以便在父页面打开新页面，否则直接打开新页面
 * @param {string} href
 */
export default function onClickLink(href) {
  if (!isInIframe) {
    window.open(href, '_blank');
    return;
  }
  window.parent.postMessage(
    {
      source: 'ChatAI',
      action: 'onClickLink',
      payload: {
        href,
      },
    },
    '*',
  );
}
